<div class="container">
  <h1>Importante</h1>
  <p>
    Hola, <b>te sugerimos hablar con tu banco previamente para evitar inconvenientes</b> debido a
    que este es tu segundo retiro en dólares del mes y muchos bancos rebotan la segunda
    transferencia.
  </p>
  <div class="link">
    <a href="http://www.bcra.gov.ar/Pdfs/comytexord/A7072.pdf" target="_blank"
      >* Normativa COM 'A' 7072 emitida por el BCRA.</a
    >
  </div>
  <div class="buttons">
    <button class="td-btn green" (click)="dialogRef.close(true)">Retirar igual</button>
    <button class="td-btn black" (click)="dialogRef.close(false)">Cancelar retiro</button>
  </div>
</div>
